import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'
import Emitter from 'assets/js/utils/emitter.js'
import ScrollTrigger from 'gsap/ScrollTrigger'
import gsap from 'gsap'

gsap.registerPlugin(ScrollTrigger)

export default class RefreshScrollTrigger {
  constructor() {
    this.isQueued = false
    this.init()
  }

  init() {
    Emitter.on(GLOBAL_CONSTANTS.EVENTS.LAZY_LOADED, (img) => {
      if (this.isQueued) {
        return
      }

      this.isQueued = true
      requestAnimationFrame(() => {
        ScrollTrigger.refresh()
        this.isQueued = false
      })
    })
  }
}
